import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { finalize, first, takeUntil } from 'rxjs/operators';
import { map } from 'rxjs/internal/operators/map';
import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ViewChildren, ElementRef, HostListener } from '@angular/core';
import { MatDialog, MatDatepickerInputEvent, MatSelect } from '@angular/material';
import { DatePipe } from '@angular/common';
import { Subscription, ReplaySubject, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { AsEnterpriseService } from 'src/app/core/services/as-enterprise.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { NgForm, FormControl } from '@angular/forms';
import { UploadMultiFileComponent } from 'src/app/shared/components/upload-multi-file/upload-multi-file.component';
import { DeactivationGuarded } from 'src/app/core/guards/confirm-deactivate.guard';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';
import Utils from 'src/app/core/services/app-utils';
import { Location } from "@angular/common";
import { AlertEkycComponent } from 'src/app/shared/components/alert-ekyc/alert-ekyc.component';
import { KycService } from 'src/app/core/services/kyc.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Common } from '../../../../../../../core/constants/common';

@Component({
  selector: 'app-update-as-enterprise',
  templateUrl: './update-as-enterprise.component.html',
  styleUrls: ['./update-as-enterprise.component.scss'],
  providers: [DatePipe]
})
export class UpdateAsEnterpriseReviewComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit, DeactivationGuarded {
  // set max date for birthday
  @BlockUI() blockUI: NgBlockUI;
  maxDate = new Date();
  minDate = new Date(1899, 12, 1);
  @ViewChild(UploadMultiFileComponent, { read: UploadMultiFileComponent, static: false }) uploadMultiFileComponent;
  @ViewChild('enterpriseTypeSelect', { static: false }) enterpriseTypeSelect: MatSelect;
  @ViewChild('certificationTypeSelect', { static: false }) certificationTypeSelect: MatSelect;
  @ViewChild('representativeCertificateSelect', { static: false }) representativeCertificateSelect: MatSelect;
  @ViewChild('citySelect', { static: false }) citySelect: MatSelect;
  @ViewChild('districtSelect', { static: false }) districtSelect: MatSelect;
  @ViewChild('wardSelect', { static: false }) wardSelect: MatSelect;
  @ViewChild('sexSelect1', { static: false }) sexSelect1: MatSelect;
  @ViewChild('sexSelect2', { static: false }) sexSelect2: MatSelect;
  @ViewChild('bankSelect', { static: false }) bankSelect: MatSelect;

  oldEnterpriseName;
  defaultAddress = {
    cityId: null,
    districtId: null,
    wardId: null,
    enterpriseId: null,
    address: '',
    isNewAddress: true
  };
  enterprisesDefaut = {
    id: null,
    name: '',
    enterpriseType: null,
    tenantId: 1,
    foreignName: '',
    parentId: null,
    parentName: '',
    abbreviation: '',
    taxCode: '',
    licenceDate: null,
    activeDate: null,
    phone: '',
    fax: '',
    primaryEmail: '',
    email: '',
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    expiryDate: null,
    accountNumber: '',
    accountName: '',
    bankName: '',
    bankBranch: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: null,
    representativeIssuedOn: '',
    status: true,
    version: null,
    birthday: null,
    adminUser: '',
    businessType: null,
    sex: true,
    file: [],
    attachments: [],
    addresses: [
      this.defaultAddress
    ]
  };

  addresses = {
    cityName: '',
    districtName: '',
    wardName: ''
  };

  customer = {
    id: null,
    enterpriseName: '',
    enterpriseId: localStorage.getItem('enterpriseId'),
    primaryEmail: null,
    customerType: 0,
    name: '',
    status: null,
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    taxCode: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: '',
    representativeIssuedAt: '',
    birthday: null,
    sex: null,
    accountNumber: '',
    accountName: '',
    bankName: '',
    bankBranch: '',
    phone: '',
    fax: '',
    email: '',
    address: '',
    cityId: null,
    wardId: null,
    districtId: null,
    attachments: [],
    adminUser: '',
    hasPermission: true,
    attachmentImages: []
  };

  isEnoughImage: boolean = false;
  title: string = '';
  pdfSrc: string;
  enterpriseName: string = '';
  private tenantId: string;
  private hashKey: string;
  public tempEnterprise: any;

  personalId = EnterpriseTypes.PERSONAL
  enterprises = this.enterprisesDefaut;
  checkAgree = false;
  checkDataenterprises = this.enterprisesDefaut;
  checkFocus = true;
  searchtenantId: '';
  searchPage: number;
  searchPageSize: number;
  searchEnterpriseId: '';
  searchTaxCode: '';
  searchStatus: [];
  searchTypes: number;
  searchKeyword: '';
  checkTax = true;
  maxLengthPhone = Common.MAX_LENGTH_PHONE;

  cities: comboBox[] = [];
  districts: districtsComboBox[] = [];
  selectedDistricts: districtsComboBox[] = [];
  wards: wardsCombobox[] = [];
  selectWards: wardsCombobox[] = [];
  error = '';
  subscription: Subscription;
  listFiles: any[] = [];
  maxSizeInput = false;
  show = true;
  change = false;
  formChangesSubscription: Subscription;
  @ViewChild('f', { static: false }) ngForm: NgForm;
  isFormChanging = false;
  @ViewChildren('focusInput') focusInput;
  enterpriseType: comboBox[] = [];
  certificateType: comboBox[] = [];
  representativeCertificateType: comboBox[] = [];
  listBankName: comboBox[] = [];
  enterpriseTypeFilterCtrl: FormControl = new FormControl();
  certificationTypeFilterCtrl: FormControl = new FormControl();
  representativeCertificateTypeFilterCtrl: FormControl = new FormControl();
  cityFilterCtrl: FormControl = new FormControl();
  districtsFilterCtrl: FormControl = new FormControl();
  wardFilterCtrl: FormControl = new FormControl();
  bankFilterCtrl: FormControl = new FormControl();

  public filteredWard: ReplaySubject<wardsCombobox[]> = new ReplaySubject<wardsCombobox[]>(1);
  public filteredDistricts: ReplaySubject<districtsComboBox[]> = new ReplaySubject<districtsComboBox[]>(1);
  public filteredCity: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredEnterpriseType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredCertificationType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredRepresentativeCertificateType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredBankName: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  private _onDestroy = new Subject<void>();
  /**
   * Check req expiredDateChange
   */
  checkIssuedDate = false;

  /**
   * Check if District hasn't Ward
   */
  notHasWard = false;
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  constructor(
    private enterpriseService: AsEnterpriseService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
    private breadcrumbsService: BreadcrumbsService,
    public message: Message,
    private toastr: ToastrService,
    private el: ElementRef,
    public customerFilter: CustomerFilterLanguage,
    public location: Location,
    private kycService: KycService,
    private customerService: CustomerService,
  ) {
    super(commonService, message);
  }

  ngOnInit() {
    this.enterpriseTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.enterpriseType, this.enterpriseTypeFilterCtrl, this.filteredEnterpriseType); });
    this.certificationTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.certificateType, this.certificationTypeFilterCtrl, this.filteredCertificationType); });
    this.representativeCertificateTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.representativeCertificateType, this.representativeCertificateTypeFilterCtrl, this.filteredRepresentativeCertificateType); });
    this.cityFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.cities, this.cityFilterCtrl, this.filteredCity); });
    this.districtsFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.selectedDistricts, this.districtsFilterCtrl, this.filteredDistricts); });
    this.wardFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.selectWards, this.wardFilterCtrl, this.filteredWard); });
    this.bankFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.commonService.filterCertificateType(this.listBankName, this.bankFilterCtrl, this.filteredBankName);
    });
    this.getBankName();
    this.getEnterpriseType();
    this.getCertificateType();
    this.getRepresentativeCertificateType();
    this.tempEnterprise = JSON.parse(localStorage.getItem('tempEnterprise'));
    // this.loadData();
    // this.loadCities();
    // this.loadDistricts();
    // this.loadWards();
    this.commonService.getCategory().subscribe(result => {
      this.cityList[1] = result[0].data.filter(item => !item.isNew)
      this.districtList[1] = result[1].data.filter(item => !item.isNew)
      this.wardList[1] = result[2].data.filter(item => !item.isNew);
      this.cityList[0] = result[3].data
      this.districtList[0] = []
      this.wardList[0] = result[4].data;
      this.cities = result[0].data;
      this.districts = result[1].data;
      this.wards = result[2].data;
      this.filteredCity.next(this.cities.slice());
      this.loadData();
    })
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
    this.breadcrumbsService.store([
      { label: 'breadcrumbs.home', url: 'main', params: [], highlight: false },
      { label: 'breadcrumbs.enterprise_info', url: '', params: [], highlight: false },
      { label: 'update_enterprise.screen_name_new', url: '', params: [], highlight: false },
    ]);

    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        this.searchtenantId = params.tenantId || 0;
        this.searchPage = params.page || 0;
        this.searchPageSize = params.pageSize || 0;
        this.searchEnterpriseId = params.enterpriseId || '';
        this.searchTypes = params.types;
        this.searchStatus = params.status;
        this.searchTaxCode = params.taxCode || '';
        this.searchKeyword = params.keyword || '';
      });

    this.route.paramMap.subscribe(params => {
      this.hashKey = params.get('hashKey');
      this.tenantId = params.get('tenantId');
    });
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty || this.ngForm.touched) {
        this.isFormChanging = true;
      }
    });
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Update data
   */
  onCLickButtonSave() {
    if (this.isFormChanging || this.uploadMultiFileComponent.isFormChanging) {
      const dialogRef = this.dialog.open(WarningComponent, {
        width: '350px',
        // them ten doanh nghiep
        data: this.commonService.format(this.message.getMessage('messages.confirm_update_enterprise'), this.oldEnterpriseName)
      });
      dialogRef.afterClosed().subscribe(rs => {
        if (rs) {
          this.uploadMultiFileComponent.uploadFile((attachments) => {
            this.enterprises.attachments = attachments;
            this.updateEnterprise();
          }, () => {
            this.updateEnterprise();
          });
        }
      });
    }
  }

  /**
   * Call update enterprise service and push data to server.
   * @param dialogRe: Dialog result confirmation.
   */
  private updateEnterprise() {
    this.enterpriseService.updateEnterprise(
      this.enterprises.id,
      this.enterprises,
      () => {
        this.show = false;
        this.toastr.success(this.message.getMessage('messages.update_success'));
        this.location.back();
      },
      () => {
        this.loadData();
      },
      this.onUpdateEnterpriseError.bind(this)
    );
  }

  private onUpdateEnterpriseError(rs: any) {
    if (!rs.success) {
      switch (rs.code) {
        case '0x00118':
          this.certificateNoExistingHanlder(rs);
          break;
        case '0x00117':
          this.taxNoExistingHanlder(rs);
          break;
        default:
          this.notificationService.notify(Utils.toErrorMessage(rs, this.message.getMessage('messages.error_message')));
          break;
      }
    }
  }

  private certificateNoExistingHanlder(rs: any): void {
    this.ngForm.form.controls.certificateNo.setErrors({ incorrect: true, duplicate: true });
    document.getElementById("certificateCodeId").focus();
  }
  private taxNoExistingHanlder(rs: any): void {
    this.ngForm.form.controls.taxCode.setErrors({ incorrect: true, duplicate: true });
    document.getElementById("taxCodeId").focus();

  }

  /**
   * Load all cities
   */
  loadCities() {
    // if (localStorage.getItem('cities') === null) {
    this.getCitiesRedis().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        this.cities = data;
        localStorage.setItem(
          'cities',
          JSON.stringify(this.cities),
        );
        this.filteredCity.next(this.cities.slice());
      }
    });
    // } else {
    //   this.cities = JSON.parse(
    //     localStorage.getItem('cities')
    //   );
    //   this.filteredCity.next(this.cities.slice());
    // }
  }

  /**
   * Load all districts
   */
  loadDistricts() {
    // if (localStorage.getItem('districts') === null) {
    this.getDistrictsRedis().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        this.districts = data;
        localStorage.setItem(
          'districts',
          JSON.stringify(this.districts),
        );
      }
    });
    // } else {
    //   this.districts = JSON.parse(
    //     localStorage.getItem('districts')
    //   );
    // }
  }

  /**
   * Load all wards
   */
  loadWards() {
    // if (localStorage.getItem('wards') === null) {
    this.getWardsRedis().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        this.wards = data;
        localStorage.setItem(
          'wards',
          JSON.stringify(this.wards),
        );
      }
    });
    // } else {
    //   this.wards = JSON.parse(
    //     localStorage.getItem('wards')
    //   );
    // }
  }

  /**
   * Call api to get data for update
   */
  loadData() {
    if (this.tempEnterprise != null) {
      const responsedData = this.tempEnterprise;
      this.enterpriseName = this.enterprises.name

      if (responsedData.addresses == null || responsedData.addresses.length == 0) {
        responsedData.addresses = [this.defaultAddress];
      }
      //check data from origin 
      this.enterprises = responsedData;
      //this.checkDataenterprises.taxCode = '';
      if(JSON.parse(localStorage.getItem('checkTax')) === false){
        this.checkTax = false;
      }

      
      this.oldEnterpriseName = this.enterprises.name;
      this.enterprises.issuedDate = new Date(this.tempEnterprise.issuedDate);
      if (this.enterprises.representativeIssuedDate != null) {
        this.enterprises.representativeIssuedDate = new Date(this.tempEnterprise.representativeIssuedDate);
      } else {
        // tslint:disable-next-line: no-unused-expression
        this.enterprises.representativeIssuedDate = null;
      }
      if (this.enterprises.birthday != null) {
        this.enterprises.birthday = new Date(this.tempEnterprise.birthday);
      } else {
        // tslint:disable-next-line: no-unused-expression
        this.enterprises.birthday = null;
      }
      this.enterprises.addresses[0].isNewAddress = !!responsedData.addresses[0].isNewAddress
        if(this.enterprises.addresses[0].isNewAddress){
          this.cities = this.cityList[0]
          this.districts = this.districtList[0]
          this.wards = this.wardList[0]
        } else {
          this.cities = this.cityList[1]
          this.districts = this.districtList[1]
          this.wards = this.wardList[1]
        }
        this.filteredCity.next(this.cities.slice());
        if(!this.enterprises.addresses[0].isNewAddress){
          this.selectedDistricts = this.districts.filter(x => {
            return x.cityId == this.enterprises.addresses[0].cityId;
          });
          this.filteredDistricts.next(this.selectedDistricts.slice());
          this.selectWards = this.wards.filter(x => {
            return x.districtId == this.enterprises.addresses[0].districtId;
          });
          this.filteredWard.next(this.selectWards.slice());
        } else {
          this.selectWards = this.wards.filter(x => {
            return  x.cityId == this.enterprises.addresses[0].cityId;
          });
          this.filteredWard.next(this.selectWards.slice());
        }
    } else {
      this.enterprises = this.enterprisesDefaut;
    }
  }

  /**
   * Handle event when change city and district
   *  @param value:
   *  @param opt:
   */
  onChange(value: number, opt: number = 1) {
    switch (opt) {
      case 1:
        this.selectedDistricts = this.districts.filter(x => {
          this.selectWards = null;
          this.enterprises.addresses[0].districtId = null;
          this.enterprises.addresses[0].wardId = null;
          return x.cityId == value;
        });
        this.filteredDistricts.next(this.selectedDistricts.slice());
        this.filteredWard = new ReplaySubject<wardsCombobox[]>(1);
        break;
      case 2:
        this.selectWards = this.wards.filter(x => {
          this.enterprises.addresses[0].wardId = null;
          if(this.enterprises.addresses[0].isNewAddress){
            return x.cityId === value;
          } else {
            return x.districtId === value;
          }
        });
        this.filteredWard.next(this.selectWards.slice());
        if (this.selectWards.length === 0) {
          this.notHasWard = true;
        } else {
          this.notHasWard = false;
        }
        break;
      default:

        break;
    }
  }

  /**
   * Event when click button cancel
   */
  onNoClick() {
    const dialogRe = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.message.getMessage('messages.confirm_change_data')
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        this.show = false;
        this.router.navigate(['/home-enterprise/kyc-confirm-account-review-enterprise'], {});
      }
      dialogRe.close();
    });
  }

  /**
   * Call api to get customer by id
   * @param id: number
   */
  //  getCustomer() {
  //   const body = {
  //     hashKey: this.hashKey,
  //     tenantId: this.tenantId
  //   }
  //   this.customerService.getDetailCustomer(body).subscribe(
  //     rs => {
  //       if (rs == null || rs.data == null) {
  //         return 0;
  //       }
  //       this.customer = {
  //         ...this.customer,
  //         ...rs.data,
  //         issuedDate: rs.data.issuedDate != null ? new Date(rs.data.issuedDate) : null,
  //         representativeIssuedDate: rs.data.representativeIssuedDate != null ? new Date(rs.data.representativeIssuedDate) : null,
  //         birthday: rs.data.birthday != null ? new Date(rs.data.birthday) : null
  //       };
  //       if(this.customer.attachmentImages && this.customer.attachmentImages.length == 3){
  //         this.isEnoughImage = true
  //       }
  //       this.title = this.commonService.format(
  //         this.message.getMessage('kyc.note_inconrect_info'), this.customer.enterpriseName);
  //       this.getEnterpriseType();
  //       this.loadData();

  //       // var cityItem = (this.customer.cityId != null) ? this.cities.find(x => x.id === this.customer.cityId) : undefined;
  //       // var districtItem = (this.customer.districtId != null) ? this.districts.find(x => x.id === this.customer.districtId) : undefined;
  //       // var wardItem = (this.customer.wardId != null) ? this.wards.find(x => x.id === this.customer.wardId) : undefined;
  //       this.addresses = {
  //         cityName: (this.customer.cityId != null) ? this.cities.find(x => x.id === this.customer.cityId).name : '',
  //         districtName: (this.customer.districtId != null) ? this.districts.find(x => x.id === this.customer.districtId).name : '',
  //         wardName: (this.customer.wardId != null) ? this.wards.find(x => x.id === this.customer.wardId).name : '',
  //       };
  //       this.getCertificateType();
  //       this.getRepresentativeCertificateType();
  //       this.viewDocumentUpload();
  //     }
  //   );
  // }

  viewDocumentUpload() {
    this.kycService.verifyAccountGetPdf().subscribe(res => {
      this.showPdf(res);
    });
  }

  showPdf(blob: any) {
    const file = this.blobToFile(blob, 'application/pdf');

    this.commonService.readFile(file, (pdfSrc) => {
      this.pdfSrc = pdfSrc;
      console.log(pdfSrc);

    });
  }

  onlyTaxChars(event: KeyboardEvent): boolean {
    const charCode = event.key;
    const regex = /[0-9-]/;
    
    if (!regex.test(charCode)) {
      event.preventDefault(); // Chặn ký tự không hợp lệ
      return false;
    }
    return true;
  }


  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  }




  onSign() {
    localStorage.setItem('tempEnterprise', JSON.stringify(this.enterprises))
    this.router.navigate(['/home-enterprise/kyc-confirm-account-review-enterprise'], {});
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    const tenantId = localStorage.getItem('tenantId');
    if ((this.isFormChanging && this.show && tenantId != null)
      || (this.uploadMultiFileComponent.isFormChanging && this.show && tenantId != null)
      || (this.change && this.show && tenantId != null)) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    } else {
      return true;
    }
  }

  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.change = true;
  }

  getBankName() {
    this.commonService.getBankName().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.listBankName = result;
        this.filteredBankName.next(this.listBankName.slice());
      }
    });
  }

  /**
   * Get enterprise type list
   */
  getEnterpriseType() {
    this.commonService.getEnterpriseType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.enterpriseType = result;
        this.filteredEnterpriseType.next(this.enterpriseType.slice());
      }
    });
  }

  /**
   * Get certificate list
   */
  getCertificateType() {
    this.commonService.getCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.certificateType = result;
        this.filteredCertificationType.next(this.certificateType.slice());
      }
    });
  }

  /**
   * Get representative certificate list
   */
  getRepresentativeCertificateType() {
    this.commonService.getRepresentativeCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.representativeCertificateType = result;
        this.filteredRepresentativeCertificateType.next(this.representativeCertificateType.slice());
      }
    });
  }

  /**
   * Check req for checkIssuedDate
   */
  checkIssuedDateChange(value) {
    if (value == null || value == '' || value == undefined) {
      this.checkIssuedDate = true;
    } else {
      this.checkIssuedDate = false;
    }
  }

  onAttachmentChange(event) {
    this.isFormChanging = event;
  }
  getEnterpriseTypeOptions(options) {
    return this.customerFilter.filterOptionsData(options);
  }

  onClickBtnViewUpdate(route: string, id: string) {
    const status: [] | any = this.enterprises.status == null ? [true, false] : [(this.enterprises.status)];

    this.router.navigate([route + id], {
      queryParams: {
        tenantId: localStorage.getItem('tenantId'),
        page: 0,
        pageSize: 10,
        enterpriseId: id,
        taxCode: this.enterprises.taxCode,
        keyword: '',
        status: status.toString(),
      }
    });
  }

  cityList: any[] = []
  districtList: any[] = []
  wardList: any[] = []

  changeAddress(event: boolean){
    if(this.enterprises.addresses[0].isNewAddress == event){
      return
    } 
    this.enterprises.addresses[0].isNewAddress = event
    console.log(event);
    
    if(event){
      this.cities = this.cityList[0]
      this.districts = this.districtList[0]
      this.wards = this.wardList[0]
      if(!(!this.enterprises.addresses[0].cityId && !this.enterprises.addresses[0].districtId && !this.enterprises.addresses[0].wardId)){
        this.blockUI.start()
        const id = this.enterprises.addresses[0].wardId ? this.enterprises.addresses[0].wardId : this.enterprises.addresses[0].districtId ? this.enterprises.addresses[0].districtId : this.enterprises.addresses[0].cityId
        this.enterprises.addresses[0].cityId = null
        this.enterprises.addresses[0].districtId = null
        this.enterprises.addresses[0].wardId = null
        this.onChange(null, 2)
        this.commonService.changeNewAddress(id).pipe(finalize(()=> this.blockUI.stop())).subscribe(res =>{
          console.log(res, res.data._return.lstProductSpecCharDTOs);
          if(res.success){
            if(res.data._return.lstProductSpecCharDTOs && res.data._return.lstProductSpecCharDTOs.length > 0){
              this.enterprises.addresses[0].cityId = res.data._return.lstProductSpecCharDTOs[0].province;
              this.onChange(this.enterprises.addresses[0].cityId, 2)
              if(res.data._return.lstProductSpecCharDTOs[0].precinct){
                this.enterprises.addresses[0].wardId = this.enterprises.addresses[0].cityId + res.data._return.lstProductSpecCharDTOs[0].precinct;
              }
            }
          } else {
            this.toastr.error(res.message)
          }
        })
      } else {
        this.onChange(null, 2)
      }
    } else {
      this.cities = this.cityList[1]
      this.districts = this.districtList[1]
      this.wards = this.wardList[1]
      this.enterprises.addresses[0].cityId = null
      this.enterprises.addresses[0].districtId = null
      this.enterprises.addresses[0].wardId = null
      this.onChange(null)
    }
    this.cityFilterCtrl.patchValue('')
    this.districtsFilterCtrl.patchValue('')
    this.wardFilterCtrl.patchValue('')
  }
}
